/* eslint-disable */

import _ from 'lodash'

function validNumber(num: number) {
  return typeof num === 'number' && !Number.isNaN(num) && Math.abs(num) !== Infinity
}

function getArray({ start = 0, end = 0, reverse = false }: { start?: number; end?: number; reverse?: boolean }) {
  if (!validNumber(start) && !validNumber(end)) return []
  let min = Math.max(0, Math.min(start, end))
  let max = Math.max(0, start, end)
  if (min === max) return [min]
  if (min > max) {
    ;[min, max] = [max, min]
  }
  let length = max - min + 1
  if (!validNumber(length) || length < 0) length = 0
  const array = Array(length)
    .fill(0)
    .map((v, i) => min + i)
  return reverse ? array.reverse() : array
}

/** 给定两个数组，移除两个数组中的交集部分，返回无交集的集合; 并集与交集做差集 */
const removeIntersectionItem = (arr1: number[], arr2: number[]) => {
  if (!arr1.length && !arr2.length) return []
  if (!arr1.length) return arr2
  if (!arr2.length) return arr1
  return _.difference(_.concat(arr1, arr2), _.intersection(arr1, arr2)).sort((a, b) => a - b)
}

/*
 计算栅格视图框选范围
 例如有列表
 [
 0, 1, 2, 3,
 4, 5, 6, 7,
 8, 9
 ]
 一行有4列，假设框选[2, 7], 则实际被选中的是：[[2, 3], [6, 7]]
 */
function getGridSwipeRange(path: [number, number], grid: number = 1, listLength = Infinity) {
  const swipePaths: (typeof path)[] = []
  if (grid === 1) return [path]
  const len = ((path[1] - path[0]) % grid) + 1
  const splitLen = grid - len
  const range = getArray({ start: path[0], end: path[1] })
  let i = 0
  while (i < range.length) {
    const end = i + len
    const p = range.slice(i, end)
    const min = Math.min(...p)
    if (min >= listLength) break // 最小值超过列表长度，不再处理
    swipePaths.push([min, Math.max(...p)])
    i = end + splitLen
  }
  return swipePaths
}

// 记录文件选中的操作顺序
export default class {
  /* 记录最近的选中记录 */
  lastPath: number | undefined = undefined
  /* 选中范围 */
  range: number[] = []
  // 最近框选的范围
  lastSwipePath: [number, number] | undefined = undefined

  /** 用于单选 */
  setPath(path: number | [number, number]) {
    this.reset()
    return this.push(path)
  }

  /**
   * 用于多选或框选
   * path为number类型时表示多选，每次push一个记录
   * path为[number,number]类型时表示框选，每次push起始和结束位置
   */
  push(path: number | [number, number], needPushWhenExists = true) {
    if (typeof path === 'number') {
      const idx = this.range.findIndex(i => i === path)
      if (idx !== -1 && !needPushWhenExists) return this.range
      if (idx === -1) {
        // 不在选中范围内，记录
        this.lastPath = path
      } else {
        // 在选中范围内，取后一个选中（若无则取前一个）的作为记录
        this.lastPath = this.range[idx + 1] || this.range[idx - 1]
      }
      this.range = removeIntersectionItem([path], this.range)
    } else if (Array.isArray(path)) {
      const min = Math.min(...path)
      const max = Math.max(...path)
      // 以起始位置为基点，查找下一个不在range范围内的作为记录
      let nextPath = min
      let idx = this.range.findIndex(i => i === nextPath)
      let firstIdx = idx
      while (nextPath <= max && idx !== -1) {
        nextPath += 1
        idx = this.range.findIndex(i => i === nextPath)
      }
      // min~max 如果都包含在range内，则取min的上一个选中作为记录，如果没有就取max的后一个作为记录
      this.lastPath = nextPath <= max ? nextPath : this.range[firstIdx - 1] || this.range[idx]
      this.range = removeIntersectionItem(getArray({ start: min, end: max }), this.range)
    }
    if (!this.lastPath && this.range.length > 0) {
      this.lastPath = this.range[0]
    }
    // console.log('push ', path, ' >> ', this.lastPath, this.range)
    return this.range
  }

  /** 连续多选，比如方向键上下左右移动 */
  shiftPush(path: number, direct: -1 | 1) {
    if (this.lastPath === undefined) {
      return this.push(path)
    }
    // 找到包含记录点的连续区块的起始点和结束点
    let idx = this.range.findIndex(i => i === this.lastPath)
    let start = idx
    let end = idx
    while (end < this.range.length && this.range[end + 1] === this.range[end] + 1) {
      end += 1
    }
    while (start > 0 && this.range[start - 1] === this.range[start] - 1) {
      start -= 1
    }
    const firstRange = this.range[start]
    const lastRange = this.range[end]
    if (direct === 1) {
      // 向序号增大的方向移动
      // 选中收缩
      if (lastRange >= path && path >= firstRange) {
        // 不能直接push(path)的原因是在栅格视图下，path和lastPath可能不连续
        // 比如栅格视图，一行4个时，当lastPath=1 ，向下移动，此时path=5，需要把 [2, 3, 4, 5] 选中
        getArray({ start: this.lastPath, end: path - 1 }).forEach(p => {
          this.push(p)
        })
      } else {
        // 选中扩大
        getArray({ start: this.lastPath + 1, end: path }).forEach(p => {
          this.push(p, false)
        })

        // 查找lastPath右侧有没有被连续选中的
        while (idx < this.range.length - 1 && this.range[idx + 1] === this.range[idx] + 1) {
          idx += 1
          this.lastPath = this.range[idx]
        }
      }
    } else {
      // 向序号增大的方向移动
      // 选中扩大
      if (path < firstRange) {
        getArray({ start: path, end: this.lastPath - 1, reverse: true }).forEach(p => {
          this.push(p, false)
        })
        // 查找lastPath左侧侧有没有被连续选中的
        while (idx > 0 && this.range[idx - 1] === this.range[idx] - 1) {
          idx -= 1
          this.lastPath = this.range[idx]
        }
      } else {
        // 选中收缩
        getArray({ start: path + 1, end: this.lastPath, reverse: true }).forEach(p => {
          this.push(p)
        })
      }
    }
    return this.range
  }

  /**
   * 框选
   * 框选是连续行为，因此可能连续调用该方法，需要记录上一次push的路径，跟本次push的路径做比较，如果相同则不处理
   * 在栅格视图下，还需要先计算出实际被包含的路径，比如 一行4个，框选[0, 5]，被选中的只有 [0, 1, 4, 5]
   */
  swipePush(path?: [number, number], grid: number = 1, listLength = Infinity) {
    const ps = path?.filter(p => p !== -1 && p !== undefined) as typeof path
    if (!ps || !ps.length || ps.length !== 2) {
      this.lastSwipePath = undefined
      return this.range
    }
    const swipePaths = getGridSwipeRange(ps, grid, listLength)

    // 未被框选，直接选中
    if (!this.lastSwipePath) {
      this.lastSwipePath = ps
      swipePaths.forEach(p => {
        this.push(p)
      })
      return this.range
    }

    // 本次框选于上次框选范围是一样的
    if (this.lastSwipePath[0] === ps[0] && this.lastSwipePath[1] === ps[1]) {
      return this.range
    }

    // 先将上次框选的内容取消选中，再进行选中
    const lastSwipePaths = getGridSwipeRange(this.lastSwipePath, grid, Infinity)
    lastSwipePaths.forEach(p => {
      this.push(p)
    })

    this.lastSwipePath = ps
    swipePaths.forEach(p => {
      this.push(p)
    })
    return this.range
  }

  /** 用于跨选 */
  selectRange(path: number) {
    if (this.lastPath === undefined) {
      this.setPath(path)
    } else {
      const length = this.range.length
      const idx = this.range.findIndex(i => i === this.lastPath)
      // 进行跨选时，先将起始点接壤的所有选中项移除
      let i = idx
      let nextValue = this.lastPath
      if (path > this.lastPath) {
        // 结束点在起始点右侧，清空起始点左侧连续选中的记录和起始点到结束点见选中的记录
        while (i >= 0 && this.range[i - 1] === nextValue - 1) {
          i -= 1
          this.range[i] = -1
          nextValue -= 1
        }
        i = idx
        while (i < length) {
          const p = this.range[i]
          if (p > path) break
          if (this.lastPath <= p && p < path) {
            this.range[i] = -1
          }
          i += 1
        }
        // 若结束点后有连续选中的，也需要清除
        let pathIndex = this.range.findIndex(i => i === path)
        if (pathIndex !== -1) {
          let prevValue = this.range[pathIndex]
          this.range[pathIndex] = -1
          while (pathIndex < length - 1 && this.range[pathIndex + 1] === prevValue + 1) {
            pathIndex += 1
            prevValue = this.range[pathIndex]
            this.range[pathIndex] = -1
          }
        }
      } else {
        // 结束点在起始点左侧，清空起始点右侧连续选中的记录和起始点到结束点见选中的记录
        while (i < length && this.range[i + 1] === nextValue + 1) {
          i += 1
          this.range[i] = -1
          nextValue += 1
        }
        i = idx
        while (i >= 0) {
          const p = this.range[i]
          if (p < path) break
          if (path < p && p <= this.lastPath) {
            this.range[i] = -1
          }
          i -= 1
        }
        // 若结束点前有连续选中的，也需要清除
        let pathIndex = this.range.findIndex(i => i === path)
        if (pathIndex !== -1) {
          let prevValue = this.range[pathIndex]
          this.range[pathIndex] = -1
          while (pathIndex > 0 && this.range[pathIndex - 1] === prevValue - 1) {
            pathIndex -= 1
            prevValue = this.range[pathIndex]
            this.range[pathIndex] = -1
          }
        }
      }
      this.range = removeIntersectionItem(
        getArray({ start: this.lastPath, end: path }),
        this.range.filter(i => i !== -1),
      )
    }
    // console.log('selectRange ', path, ' >> ', this.lastPath, this.range)
    return this.range
  }

  reset() {
    this.lastPath = undefined
    this.range = []
    this.lastSwipePath = undefined
  }

  get firstSelect() {
    return this.range[0]
  }
}
